export type UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_LANGUAGE: UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';

